import React, { useState, useEffect } from 'react';
import { Typography } from 'antd';
import PatientSelectorPanel from '../patient/PatientSelectorPanel';
import RecordingNotesSection from './RecordingNotesSection';
import PatientForm from '../patient/PatientForm';

const { Text } = Typography;

export default function VisitModalContent({
  initialPatient = null,
  sessionUuid,
  fromPatientDetails = false,
  children,
  onPatientChange
}) {
  const [selectedPatient, setSelectedPatient] = useState(initialPatient);
  const [isPatientModalOpen, setIsPatientModalOpen] = useState(false);
  const [editingPatient, setEditingPatient] = useState(null);

  const handlePatientChange = (patient) => {
    setSelectedPatient(patient);
    onPatientChange?.(patient);
  };

  return (
    <div style={{ padding: 16 }}>
      <PatientSelectorPanel
        selectedPatient={selectedPatient}
        fromPatientDetails={fromPatientDetails}
        onSelect={handlePatientChange}
        onAddPatient={() => {
          setEditingPatient(null);
          setIsPatientModalOpen(true);
        }}
        onEditPatient={() => {
          setEditingPatient(selectedPatient);
          setIsPatientModalOpen(true);
        }}
        onUnlinkPatient={() => handlePatientChange(null)}
      />

      <RecordingNotesSection 
        sessionUuid={sessionUuid}
        onPatientChange={handlePatientChange}
      />

      {/* Custom content passed as children */}
      {children}

      <PatientForm
        isOpen={isPatientModalOpen}
        editingPatient={editingPatient}
        onCancel={() => {
          setIsPatientModalOpen(false);
          setEditingPatient(null);
        }}
        onSave={(savedPatient) => {
          handlePatientChange(savedPatient);
          setIsPatientModalOpen(false);
          setEditingPatient(null);
        }}
      />
    </div>
  );
} 